export const DEFAULT = 'default';
export const SINGLE = 'single';
